import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Treatments from "./pages/Treatments";
import TreatmentDetail from "./components/Treatment";
import Staff from "./pages/Staff";
import HearingAid from "./pages/HearingAid";
import AboutPage from "./pages/About";
import Appointment from "./pages/Appointment";
import Letter from "./pages/Letter";
import AdminApp from "./pages/admin/AdminApp";

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="treatments" element={<Treatments />} />
        <Route path="/treatment/:slug" element={<TreatmentDetail />} />
        <Route path="employees" element={<Staff />} />
        <Route path="hearingaid" element={<HearingAid />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="appointment" element={<Appointment />} />
        <Route path="in" element={<Letter />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
      {!isAdmin && <Contact />}
    </>
  );
}
